import React from 'react'
import { ExecuteOperationForModelOnPipe } from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import ShiftExchangeRefreshPipes from 'support/actions/shifts/ShiftExchangeRefreshPipes'
import GetExtraFormDataPipes from 'support/pipelines/GetExtraFormDataPipes'
import Button from '../../../ui/buttons/Button'
import * as Fields from 'support/fields'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'

export default function DeclineShiftExchange ({ slotId, refreshPipes = null }) {
  return (
    <Auth.CanUseModel permission='api.shifts.exchange.decline'>
      <OnClickPipeline trigger={(
        <UI.Button color='red'>
          <Translation name='shiftexchange.actions.decline' />
        </UI.Button>
      )}
      >
        <GetExtraFormDataPipes submitButton={<Button text={<Translation name='shiftexchange.actions.decline' />} />}>
          <Fields.TabsField
            name='force_notify'
            enum='boolean_status'
            label={<Translation name='shiftexchange.forms.fields.force_notify' />}
            defaultValue={0}
          />
        </GetExtraFormDataPipes>
        <ExecuteOperationForModelOnPipe
          resourceName='shifts.exchange'
          operationName='decline'
          data={p => {
            return { force_notify: p.data.force_notify === '1' }
          }}
        />
        {refreshPipes || <ShiftExchangeRefreshPipes slotId={slotId} />}
      </OnClickPipeline>
    </Auth.CanUseModel>
  )
}
